import {
  DislikeOutlined,
  EyeOutlined,
  LikeOutlined,
  QuestionOutlined,
  TagOutlined,
  ToolOutlined,
} from '@ant-design/icons';
import type React from 'react';

export enum CATEGORY_TYPE {
  HOW_TO = 1,
  ENHANCEMENT,
  COMPLAINTS,
  PRAISE,
  OTHERS,
  EXPERIENCE,
}

export const CategoryDic: Record<CATEGORY_TYPE, string> = {
  1: 'Help',
  2: 'Enhancement',
  3: 'Complaints',
  4: 'Praise',
  5: 'Others', // 삭제 예정
  6: 'Experience',
};

export const CategoryIconDic: Record<CATEGORY_TYPE, React.FC> = {
  1: QuestionOutlined,
  2: ToolOutlined,
  3: DislikeOutlined,
  4: LikeOutlined,
  5: TagOutlined, // 삭제 예정
  6: EyeOutlined,
};

export const OrderedCategoryList: CATEGORY_TYPE[] = [
  CATEGORY_TYPE.HOW_TO,
  CATEGORY_TYPE.ENHANCEMENT,
  CATEGORY_TYPE.COMPLAINTS,
  CATEGORY_TYPE.PRAISE,
  CATEGORY_TYPE.EXPERIENCE,
  CATEGORY_TYPE.OTHERS,
];
